var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.LoopIndex !== 'last')?_c('div',{staticClass:"d-none d-md-block"},[_c('div',{staticClass:"btn bg-info  btn-lg",on:{"click":function($event){return _vm.move(  _vm.FileId, 'down' )}}},[_c('i',{staticClass:"fas fa-arrow-right"})])]):_vm._e()}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29c84e0a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/MoveFileBlock.vue
// module id = yXLd
// module chunks = 0